import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConfigurationProfilesWebComponentSchema, RpcAction, RpcCompanyMethod, RpcExclusionListsMethod } from '../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { AvailableCompaniesSource } from '@nirvana/shared/dtos/types/dashboards/gz-console';
import { Target } from '@nirvana/shared/dtos/types/dashboards/common';

export class ConfigurationProfilesBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<ConfigurationProfilesWebComponentSchema> {
    throw new Error('Not implemented');
  }

  public async getAvailableCompanies() {
    return ConsoleRequest.createRequest<{ data: Array<Target> }>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        source: AvailableCompaniesSource.FROM_CONFIGURATION_PROFILES,
        options: {countRecords: false},
      },
      endpoint: RpcAction.COMPANY,
      method: RpcCompanyMethod.GET_AVAILABLE_COMPANIES,
    });
  }

  public async assignListToPolicies(companyId: string, listId: string, policyIds: string[]): Promise<{ success: boolean }> {
    return ConsoleRequest.createRequest<{ success: boolean }>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        targetCompanyId: companyId,
        listId: listId,
        policyIds: policyIds,
      },
      endpoint: RpcAction.EXCLUSION_LISTS,
      method: RpcExclusionListsMethod.ASSIGN_TO_POLICIES,
    });
  }

  public async removeRecords(records): Promise<{ success: boolean }> {
    return ConsoleRequest.createRequest<{ success: boolean }>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        records: records,
      },
      endpoint: RpcAction.EXCLUSION_LISTS,
      method: RpcExclusionListsMethod.REMOVE_RECORDS,
    });
  }
}
